<template>

  <div class="modal fade" id="view-admin-announcement" tabindex="-1" role="dialog"
       aria-labelledby="view-admin-announcement" aria-hidden="true" data-backdrop="static"
       data-keyboard="false">
    <div class="modal-dialog modal-dialog-centered" role="document"
    >
      <div class="modal-content">
        <div class="modal-header">

          <div class="form-inline">
            <div class="form-group mr-5">
              <span class="font-weight-bold lead" style="font-size: 20px;">
                Announcement Details
              </span>
            </div>
            <div class="form-group">
              <button type="submit" class="btn btn-warning btn-sm btn-xs mr-3 font-weight-bolder"
                      v-if="!guest"
                      @click="confirmUpdateAdminAnnouncement"
              >
                <i class="fas fa-edit"></i>
                {{ editable ? 'Update' : 'Edit' }}
              </button>
              <button class="btn btn-danger btn-sm btn-xs font-weight-bolder"
                      v-if="editable"
                      @click="cancelEdit"
              >
                <span class="fas fa-ban"></span>
              </button>
            </div>
          </div>

<!--          <h5 class="modal-title font-weight-bolder" id="view-admin-announcement">-->
<!--            Announcement Details-->
<!--          </h5>-->

<!--          <div class="ml-5">-->
<!--            <button type="submit" class="btn btn-warning btn-sm btn-xs mr-3 font-weight-bolder"-->
<!--                    v-if="!guest"-->
<!--                    @click="confirmUpdateAdminAnnouncement"-->
<!--            >-->
<!--              <i class="fas fa-edit"></i>-->
<!--              {{ editable ? 'Update' : 'Edit' }}-->
<!--            </button>-->
<!--            <button class="btn btn-danger btn-sm btn-xs font-weight-bolder"-->
<!--                    v-if="editable"-->
<!--                    @click="cancelEdit"-->
<!--            >-->
<!--              <span class="fas fa-ban"></span>-->
<!--            </button>-->
<!--          </div>-->

          <button type="button" id="close-view-admin-announcement" class="close"
                  data-dismiss="modal" aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>


        <div class="modal-body text-small">

          <form @submit.prevent="confirmUpdateAdminAnnouncement">


          <div class="form-group form-row mb-1">
            <label class="col col-sm-3 col-form-label font-weight-bolder text-left" for="injury-name" >
              Title:
            </label>
            <div class="col col-sm-9">
              <input type="text" id="new-announcement-title"
                     class="form-control form-control-xs"
                     :readonly="!editable"
                     placeholder="Enter Announcement Title Here"
                     v-model="adminAnnouncement.title"
              >
            </div>
          </div>

          <div class="form-group form-row mb-1">
            <label class="col col-sm-3 col-form-label font-weight-bolder text-left" for="injury-name" >
              Message:
            </label>
            <div class="col col-sm-9">
              <textarea type="text" id="new-announcement-message" class="form-control"
                        rows="15" cols="30" style="font-size: 9pt"
                        :readonly="!editable"
                        placeholder="Enter Announcement Message"
                        v-model="adminAnnouncement.message"
              >
          </textarea>
            </div>
          </div>

          <div class="form-group form-row mb-1">
            <label class="col col-sm-3 col-form-label font-weight-bolder text-left" for="injury-name" >
              Date From:
            </label>
            <div class="col col-sm-9">
              <input type="date" id="new-announcement-from" class="form-control form-control-xs"
                     :readonly="!editable"
                     v-model="adminAnnouncement.date_from"
              >
            </div>
          </div>

          <div class="form-group form-row mb-2">
            <label class="col col-sm-3 col-form-label font-weight-bolder text-left" for="injury-name" >
              Date To:
            </label>
            <div class="col col-sm-9">
              <input type="date" id="new-announcement-to" class="form-control form-control-xs"
                     :readonly="!editable"
                     v-model="adminAnnouncement.date_to"
              >
            </div>
          </div>


            <div class=" table-responsive text-small addScroll">
              <table class="table table-hover table-bordered table-template-1 text-small sticky-header">
                <thead>
                <tr>
                  <th class="col-type-width">Attachment Name</th>
                  <th>File</th>
                  <th v-if="editable"></th>
                </tr>
                </thead>

                <tbody>
                <tr v-for="(announcementAttachment, index) in viewExpenseAttachments" :key="index">

                  <td style="text-align: center;">
                    <span class="bg-light-danger font-weight-bolder">{{ announcementAttachment.name }}</span>
                  </td>
                  <td style="text-align: center;">
                    <a type="button" class="text-primary"
                       title="View Attachment"
                       @click="loadAttachmentFile(announcementAttachment.id, index, announcementAttachment.name)"
                    >View File</a>
                  </td>
                  <td style="text-align: center;" v-if="editable">
                    <button type="button"
                            class="btn btn-outline-danger btn-sm btn-xs font-weight-bold"
                            @click="deleteFileAttachment(index, announcementAttachment.id)"
                            :disabled="!editable"
                    >
                      <!--                    <i class="fas fa-minus"></i>-->
                      ✖
                    </button>
                  </td>
                </tr>

                <tr v-if="adminAnnouncement.announcement_attachment ? (adminAnnouncement.announcement_attachment.length == 0) : '' ">
                  <td colspan="100%" class="bg-light-danger font-weight-bolder">
                    <p class="text-center mt-3">No attachments found</p>
                  </td>
                </tr>

                </tbody>
              </table>

            </div>



            <!--          Add Expense Attachment with remove all button-->
            <div class="d-flex justify-content-end">
              <template v-if="addedAttachments.length">
                <button type="button"
                        class="btn btn-outline-danger btn-sm btn-xs border-0 p-1 mr-3 mb-3 font-weight-bold"
                        @click="removeAllAttachments"
                        v-if="editable"
                >
                  <i class="fas fa-minus-circle"></i> Remove All
                </button>
              </template>

              <button type="button" class="btn btn-primary btn-sm btn-xs mb-3 font-weight-bold"
                      @click="addAttachment"
                      v-if="editable"
              >
                <i class="fas fa-plus-circle mr-1"></i>Add Attachment/s
              </button>

            </div>


            <div class="addScroll">
              <!--          Add expense attachment -->
              <div v-if="editable">
                <!--                original class = d-flex justify-content-center form-group row mb-2 py-2 bg-light border-top-->
                <div class="d-flex justify-content-center form-group bg-light py-1"
                     v-for="(attachment, index) in addedAttachments" :key="index">
                  <div class="col-sm-8 mb-1 mt-3">
                    <button type="button"
                            class="float-right btn btn-outline-danger btn-sm btn-xs font-weight-bold mb-1 "
                            @click="removeAttachment(index)"
                    >
                      ✖
                    </button>

                    <input type="text"
                           class="form-control mb-1"
                           placeholder="Enter attachment name"
                           v-model="attachment.name">

                    <label class="btn btn-secondary btn-sm mt-1"
                           :for="'attachment' + index"
                           :id="'label' + index"
                    >
                      Choose file
                    </label>

                    <div class="custom-file form-control-sm">
                      <input type="file" class="custom-file-input"
                             :id="'attachment' + index" required
                             accept="application/pdf"
                             @change="updateFileLabel(index)"
                      >
                      <!--                <label class="custom-file-label"-->
                      <!--                       :for="'attachment' + index"-->
                      <!--                       :id="'label' + index"-->
                      <!--                >-->
                      <!--                  Choose file-->
                      <!--                </label>-->
                    </div>
                  </div>

                </div>
              </div>
            </div>

            <hr/>

          </form>

        </div>

      </div>
    </div>
  </div>

</template>

<script>
/* eslint-disable */
import {vueAppMixin} from "@/mixins/vueAppMixin";
import {formMixin} from "@/mixins/formMixin";
import {gateMixin} from "@/mixins/gateMixin";
import {mapActions, mapGetters} from "vuex";
import AppModal from "@/components/elements/AppModal";

export default {
  name: "ViewAdminAnnouncement",

  components: {AppModal},

  mixins: [vueAppMixin, formMixin, gateMixin],

  props: {
    viewAdminAnnouncement: {
      type: Object,
      default() {
        return {};
      }
    }
  },


  data() {
    return {
      adminAnnouncement: {},
      adminAnnouncementErrors: {},
      editable: false,
      addedAttachments: [],
      deletedFileAttachments: [],

      viewExpenseAttachments: {},
      viewExpenseAttachmentsCopy: {},

    }
  },

  methods: {
    ...mapActions([
      'updateAdminAnnouncement',
      'getAdminAnnouncementAttachmentFile'
    ]),

    async confirmUpdateAdminAnnouncement() {
      if (this.editable) {
        if (await this.confirmUpdate()) {

          let formData = new FormData();

          // append newAdminAnnouncement data
          let params = {};
          let ObjectData = this.adminAnnouncement;
          Object.keys(ObjectData).forEach(key => {
            params[key] = ObjectData[key];
          });

          Object.keys(params).forEach(key => {
            let value = params[key] ? params[key] : '';
            formData.append(key, value);
          });

          // append added attachments
          this.addedAttachments.forEach((addedAttachments, index) => {
            let attachment = document.getElementById(`attachment` + index);
            if (attachment.files && attachment.files[0]) {
              let file = attachment.files[0];
              formData.append(`attachment` + index, file);
            }
          });

          // append added Attachments
          formData.append('addedAttachments', JSON.stringify(this.addedAttachments));

          // append deleted Attachments
          formData.append('deletedFileAttachments', JSON.stringify(this.deletedFileAttachments));


          let updatedAdminAnnouncement = await this.updateAdminAnnouncement(formData);
          if (updatedAdminAnnouncement) {
            if (updatedAdminAnnouncement.errors) {
              this.adminAnnouncementErrors = updatedAdminAnnouncement.errors;
            } else {

              this.successAlert('Admin Announcement Successfully Updated', 'UPDATE')
              document.getElementById('close-view-admin-announcement').click();

              this.adminAnnouncement = Object.assign({}, this.viewAdminAnnouncement);

              this.deletedFileAttachments = [];
              this.addedAttachments.splice(0, this.addedAttachments.length);

              // console.log(this.viewAdminAnnouncement, 'this.viewAdminAnnouncement after edit')

            }
          } else {
            this.errorAlert('Failed to Update Admin Announcement Details', 'UPDATE');
          }
        }
      } else {
        this.editable = true;
      }
    },

    cancelEdit() {
      this.editable = false;
      this.adminAnnouncement = Object.assign({}, this.viewAdminAnnouncement);
      this.deletedFileAttachments = [];
      this.addedAttachments.splice(0, this.addedAttachments.length);
    },


    removeAllAttachments() {
      this.addedAttachments.splice(0, this.addedAttachments.length);
    },

    deleteFileAttachment(index, attachmentId) {
      this.deletedFileAttachments.push({
        adminAnnouncementAttachmentId: attachmentId,
      });

      this.viewExpenseAttachments.splice(index, 1);

    },

    addAttachment() {
      this.addedAttachments.push({
      });
    },

    removeAttachment(index) {
      this.addedAttachments.splice(index, 1);
    },

    updateFileLabel(index) {
      let fileInput = document.getElementById('attachment' + index);
      let fileLabel = document.getElementById('label' + index);
      let labelText = 'Choose File';
      if (fileInput.files && fileInput.files[0]) {
        let file = fileInput.files[0];
        labelText = file.name;
      }
      fileLabel.innerHTML = labelText;
    },

    async loadAttachmentFile(announcementId, attachmentIndex, name) {
      let params = {
        adminAnnouncementAttachmentId: announcementId
      }
      // console.log(announcementId, 'announcementId')
      let adminAnnouncementAttachmentFile = await this.getAdminAnnouncementAttachmentFile(params);
      if (adminAnnouncementAttachmentFile) {
        this.pdfViewer(name, adminAnnouncementAttachmentFile);
      }
    },


  },

  computed: {},

  watch: {
    viewAdminAnnouncement() {
      // this.adminAnnouncement = Object.assign({}, this.viewAdminAnnouncement);.
      this.adminAnnouncement = JSON.parse(JSON.stringify(this.viewAdminAnnouncement));
      this.editable = false;
    },

    'adminAnnouncement.announcement_attachment'(){
      this.viewExpenseAttachments = JSON.parse(JSON.stringify(this.viewAdminAnnouncement.announcement_attachment));
    },

  },

  mounted() {
    document.body.onkeyup = function(e){
      if(e.keyCode == 32){
        // console.log(e.keyCode, 'this is space wtf');
      }
    }



    // Object.defineProperty(KeyboardEvent.prototype, 'keyCode', {
    //   get: function() {
    //     switch (this.key) {
    //       case 'h': return 37; // left
    //       case 'j': return 40; // down
    //       case 'k': return 38; // up
    //       case 'l': return 39; // right
    //       default: return this.which
    //     }
    //   }
    // })

  },


}
</script>

<style scoped>
.addScroll {
  overflow-y: auto;
  height: 200px;
}
</style>